import { IPomReportingTableData } from "../../components/reporting-table/pom-reporting-table-data";
import { IPomReportingPosition } from "../../domain/reporting/pom-reporting";
import { IPomReportingDraftModel } from "../../repositories/models/reportings/pom-reporting-draft.model";

/** Merges the reporting's BC positions with any saved draft quantities into the table's row shape. */
export const toTableData = (
  positions: IPomReportingPosition[],
  draft: IPomReportingDraftModel | null | undefined
): IPomReportingTableData[] => {
  return positions.map((position) => {
    const draftPosition = draft?.positions.find((d) => d.positionNo === position.positionNo);
    return {
      positionNo: position.positionNo,
      itemNo: position.itemNo,
      description: position.description,
      currentQuantity: position.quantity,
      unit: position.unit,
      unitPrice: position.unitPrice,
      weightClass: position.weightClass,
      editedQuantity: draftPosition?.quantity,
    };
  });
};